const wsDisponibili = 'https://o0wh5pbm7f.execute-api.eu-west-1.amazonaws.com/default/GetOrariDisponibiliCapacita';
const wsAddPrenotazione = 'https://czz0edqoj1.execute-api.eu-west-1.amazonaws.com/default/AddPrenotazione';
//const wsAddPrenotazione = 'https://psbfceo6o2.execute-api.eu-west-1.amazonaws.com/default/AddPrenotazioneAdmin';
const wsGetInfo = 'https://koty9v7zy2.execute-api.eu-west-1.amazonaws.com/default/GetInfo';
const wsGetStato = 'https://cvyno76p4k.execute-api.eu-west-1.amazonaws.com/default/GetStatoPrenotazione';
const wsGetToken = 'https://vzxeyxcixh.execute-api.eu-west-1.amazonaws.com/default/GetDemoTokenWs';
const wsIsValidToken = 'https://smzceb5m81.execute-api.eu-west-1.amazonaws.com/default/isValidToken';
const wsGetOfferta = 'https://kqnu0jmf98.execute-api.eu-west-1.amazonaws.com/default/GetOfferta';
const wsProssimi = 'https://kmwdr65w2d.execute-api.eu-west-1.amazonaws.com/default/ProssimiDisponibili';
const wsConfermaDesktop = 'https://cap98yaar3.execute-api.eu-west-1.amazonaws.com/default/ConfermaDesktop';


var quanti = 0;
var maxQuanti = 10;
var idLoc;
var pwd;
var orari;
var orarioScelto;
var orario;
var turnoScelto;
var erroriArrivo = 0;
var cucina = 0;
var cucina1;
var cucina2;
var risDisponibili;
var prossimi;
var admin = false;
var bagnato = false;
var waserver = false;
var offerta = (typeof Cookies.get('tt_offerta') != 'undefined') ? JSON.parse(Cookies.get('tt_offerta')) : undefined;

//variabile numero telefono
var iti;



function btDay(d) {
  if (typeof idLoc !== "undefined" && idLoc != null) {
    document.getElementById("quando").value = d;
    cambiaData();
  }
}

function btAltraData() {
  if (typeof idLoc !== "undefined" && idLoc != null) {
    document.getElementById("quando").focus();
  }
}

function cambiaData() {
  document.getElementById("nav-giorno-tab").innerHTML = "Il " + document.getElementById("quando").value;
  mostra("nav-quanti-tab");
  $("#nav-quanti-tab").removeClass("disabled");
  $('#nav-quanti-tab').tab('show');
  creaBottoniQuanti();
  setTimeout(() => {
    scroll_to('nav-quanti', 500);
  }, 700);
}

function creaBottoniQuanti() {
  document.getElementById("divquanti").innerHTML = "";
  for (let i = 1; i <= maxQuanti; i++) {
    var div = document.createElement("div");
    div.setAttribute("class", "col-4");
    div.setAttribute("style", "padding: 10px;text-align: center;");
    var a = document.createElement("a");
    a.setAttribute("href", "#")
    a.setAttribute("class", "btn btn-outline-dark btn-lg")
    if (pp().includes("reserve")) {
      a.setAttribute("onclick", "btQuantiSimple(" + i + ")")
    } else {
      a.setAttribute("onclick", "btQuanti(" + i + ")")
    }
    a.setAttribute("style", "width: 50px;height:50px;")
    a.innerHTML = i
    div.appendChild(a)
    document.getElementById("divquanti").appendChild(div)
  }
}

function btQuanti(nr) {
  if (typeof idLoc !== "undefined" && idLoc != null && document.getElementById("quando").value != '') {
    quanti = nr;
    document.getElementById("nav-quanti-tab").innerHTML = quanti + " persone";
    if (typeof cucina1 != 'undefined' && typeof cucina2 != 'undefined' && cucina1.trim() != "" && cucina2.trim() != "") {
      document.getElementById("btCucina1").innerHTML = t(replaceAll(cucina1.toLowerCase(), " ", ""), pp(), cucina1)
      document.getElementById("btCucina2").innerHTML = t(replaceAll(cucina2.toLowerCase(), " ", ""), pp(), cucina2)
      mostra("nav-cucina-tab");
      $("#nav-cucina-tab").removeClass("disabled");
      $('#nav-cucina-tab').tab('show');
    } else {
      mostra("nav-ora-tab");
      $("#nav-ora-tab").removeClass("disabled");
      $('#nav-ora-tab').tab('show');
      selezionaDisponibili();
    }
  } else {
    $('#nav-giorno-tab').tab('show');
  }
}

function btQuantiSimple(nr) {
  if (typeof idLoc !== "undefined" && idLoc != null && document.getElementById("quando").value != '') {
    quanti = nr;
    document.getElementById("quantiPax").innerHTML = nr;
    selezionaDisponibiliSimple();

  }
}

function btCucina(nr) {
  if (typeof idLoc !== "undefined" && idLoc != null && document.getElementById("quando").value != '') {
    cucina = nr;
    if (cucina == 1) {
      document.getElementById("nav-cucina-tab").innerHTML = t(replaceAll(cucina1.toLowerCase(), " ", ""), pp(), cucina1);
    } else if (cucina == 2) {
      document.getElementById("nav-cucina-tab").innerHTML = t(replaceAll(cucina2.toLowerCase(), " ", ""), pp(), cucina2);
    }
    mostra("nav-ora-tab");
    $("#nav-ora-tab").removeClass("disabled");
    $('#nav-ora-tab').tab('show');
    selezionaDisponibili();
  } else {
    $('#nav-giorno-tab').tab('show');
  }
}

function isTurnoPranzo(da, a) {
  if (da.indexOf(":") > -1) {
    da = da.split(":")[0]
  }
  if (a.indexOf(":") > -1) {
    a = a.split(":")[0]
  }
  if (parseInt(da) >= 10 && parseInt(a) > 10 && parseInt(a) <= 17) {
    return true;
  } else {
    return false;
  }

}

function selezionaOrario(o, da, a) {
  if (document.getElementById("lbArrivo") != null) {
    document.getElementById("lbArrivo").innerHTML = o;
  }
  if (typeof da != 'undefined') {
    orari.forEach(turno => {
      if (turno.da === da && turno.a === a) {
        turnoScelto = turno;
      }
    });
  }
  if (pp().includes("reserve")) {
    scroll_to('divcondorario', 500);
  }
}

function popupOrario(da, a) {

  var turno;
  risDisponibili.turni.forEach(tpt => {
    if (tpt.da === da && tpt.a === a) {
      turno = tpt;
    }
  });

  document.getElementById("titoloArrivo").innerHTML = t("hscpfo", pp(), 'Hai scelto di consumare il tuo pasto nella fascia oraria che va ') + '<span style="font-weight:bold;">&nbsp;' + t("dalleore", pp(), 'dalle ore ') +
    '&nbsp;<span id="lbDa" style="font-size:larger;">' + da + '</span>&nbsp;' + t("alleore", pp(), 'alle ore') + '&nbsp;<span id="lbA" style="font-size:larger;">' + a + '</span>' + '</span>' + '.' +
    '<br/>' + t("scegliorario", pp(), 'Gli orari di arrivo ancora disponibili sono i seguenti, scegli quello di tuo gradimento') + '&nbsp;<b>' + '<span style="font-size:larger;" id="lbArrivo"></span>' + '</b>.';
  if (typeof turno != 'undefined' && typeof turno.bagnato != 'undefined' && turno.bagnato == true) {
    bagnato = true;
    document.getElementById("titoloArrivo").innerHTML = document.getElementById("titoloArrivo").innerHTML + '<br/><b>' + t("memoRain", pp(), 'Ricorda che se PIOVE la prenotazione sarà ANNULLATA !') + '</b>'
  } else {
    bagnato = false;
  }
  document.getElementById("bodyOrario").innerHTML = '';
  $('#orarioArrivo').modal('show');

  if (admin) {
    nascondi("divcondorario");
  }

  $('#chkClausola').checkboxpicker({
    offLabel: t('no', pp(), 'No'),
    onLabel: t('yes', pp(), 'Sì')
  });


  if (typeof turno === 'undefined' || typeof turno.orari === 'undefined') {

    var d = document.createElement("div");
    d.setAttribute("class", "col-4");
    d.setAttribute("style", "padding-bottom:10px");
    var b = document.createElement("button");
    b.setAttribute("type", "button");
    b.setAttribute("class", "btn btn-outline-dark");
    b.setAttribute("onclick", "selezionaOrario('" + da + "')");
    b.innerHTML = da;
    d.appendChild(b);
    document.getElementById("bodyOrario").appendChild(d);


    var procedi = true;
    var cursore = moment(document.getElementById("quando").value + " " + da, "DD-MM-YYYY HH:mm");
    var fine = moment(document.getElementById("quando").value + " " + a, "DD-MM-YYYY HH:mm").subtract(90, 'minutes');
    if (parseInt(a.split(":")[0]) < 10) {
      fine = fine.add(1, "days")
    }
    while (procedi) {
      cursore = cursore.add(15, 'minutes');
      var arrivo = moment().add(15, 'minutes');
      if (cursore.isAfter(arrivo)) {
        if (compareTime(cursore.format("HH:mm"), fine.format("HH:mm")) > 0) {
          procedi = false;
        } else {
          var d = document.createElement("div");
          d.setAttribute("class", "col-4");
          d.setAttribute("style", "padding-bottom:10px");
          var b = document.createElement("button");
          b.setAttribute("type", "button");
          b.setAttribute("class", "btn btn-outline-dark");
          b.setAttribute("onclick", "selezionaOrario('" + cursore.format("HH:mm") + "')");
          b.innerHTML = cursore.format("HH:mm");
          d.appendChild(b);
          document.getElementById("bodyOrario").appendChild(d);
        }
      }
    }
  } else {

    for (let i = 0; i < turno.orari.length; i++) {
      const orario = turno.orari[i];
      var d = document.createElement("div");
      d.setAttribute("class", "col-4");
      d.setAttribute("style", "padding-bottom:10px");
      var b = document.createElement("button");
      b.setAttribute("type", "button");
      b.setAttribute("class", "btn btn-outline-dark");
      b.setAttribute("onclick", "selezionaOrario('" + orario + "')");
      b.innerHTML = orario;
      d.appendChild(b);
      document.getElementById("bodyOrario").appendChild(d);
    }
  }

}

function scegliOrarioArrivo() {
  if (document.getElementById("lbArrivo") != null) {
    if (document.getElementById("lbArrivo").innerHTML === '???' || document.getElementById("lbArrivo").innerHTML === '') {
      errorBox(t("selopp", pp(), "Seleziona un orario di arrivo prima di procedere"));
      return;
    }

    if (!document.getElementById("chkClausola").checked && !admin) {
      errorBox(t("noclaus", pp(), "Accetta le condizioni di annullamento della prenotazione"));
      return;
    }

    $('#orarioArrivo').modal('hide');

    scegliOrario();
  }
}


function scegliOrarioArrivoSimple() {
  if (document.getElementById("lbArrivo") != null) {
    if (document.getElementById("lbArrivo").innerHTML === '???' || document.getElementById("lbArrivo").innerHTML === '') {
      errorBox(t("selopp", pp(), "Seleziona un orario di arrivo prima di procedere"));
      return;
    }

    if (!document.getElementById("chkClausola").checked) {
      errorBox(t("noclaus", pp(), "Accetta le condizioni di annullamento della prenotazione"));
      return;
    }

    scegliOrarioSimple();
  }
}

function selezionaDisponibiliSimple() {
  waitOn();
  setTimeout(() => {

    mostra("sceltaorari");
    //
    var url = wsDisponibili + '?id=' + idLoc + '&day=' + document.getElementById("quando").value + '&quanti=' + quanti + '&cucina=' + cucina;
    if (admin) {
      url = url + '&tk=' + replaceAll(Cookies.get("tt_token"), "|", "_");
    }
    $.getJSON(url, function (ris) {
      waitOff();
      risDisponibili = ris;
      //
      if (ris.chiusura) {
        nascondi("lbScegliOrari");
        var divturni = document.getElementById("divorari");
        divturni.innerHTML = "";
        var row = document.createElement("div");
        row.setAttribute("class", "row");
        var turno = document.createElement("div");
        turno.setAttribute("style", "padding: 10px;margin:auto;width:100%");
        var a = document.createElement("div");
        a.setAttribute("style", "font-size:1.25rem;border-style: solid;border-color: black;border-radius: 10px;border-width: 1px;padding: 3px;");
        a.setAttribute("class", "colorBase");
        a.innerHTML = t("locch", pp(), "Il locale in questa data è chiuso") + '&nbsp;<span style="font-size:xx-large">&#128546;</span>';
        a.style.padding = "15px";
        turno.appendChild(a);
        row.appendChild(turno);
        divturni.appendChild(row);
      } else if (ris.disabilitato) {
        waitOff();
        nascondi("lbScegliOrari");
        var divturni = document.getElementById("divorari");
        divturni.innerHTML = "";
        var row = document.createElement("div");
        row.setAttribute("class", "row");
        var turno = document.createElement("div");
        turno.setAttribute("style", "padding: 10px;margin:auto;width:100%");
        var a = document.createElement("div");
        a.setAttribute("style", "font-size:1.25rem;border-style: solid;border-color: black;border-radius: 10px;border-width: 1px;padding: 3px;");
        a.setAttribute("class", "colorBase");
        a.innerHTML = t("disabpreno", pp(), "In questa data il locale è al completo") + '&nbsp;<span style="font-size:xx-large">&#128546;</span>';
        a.style.padding = "15px";
        turno.appendChild(a);
        row.appendChild(turno);
        divturni.appendChild(row);
      } else {
        mostra("lbScegliOrari");
        orari = ris.turni;

        if (ris.turni.length > 0) {

          document.getElementById("titoloArrivo").innerHTML = t("scegliorario", pp(), 'Gli orari di arrivo ancora disponibili sono i seguenti, scegli quello di tuo gradimento');

          bagnato = false;

          document.getElementById("bodyOrario").innerHTML = '';

          $('#chkClausola').checkboxpicker({
            offLabel: t('no', pp(), 'No'),
            onLabel: t('yes', pp(), 'Sì')
          });

          trovato = false;

          ris.turni.forEach(turno => {
            for (let i = 0; i < turno.orari.length; i++) {
              const orario = turno.orari[i];
              if (orario === document.getElementById("lbArrivo").innerHTML) {
                trovato = true;
              }
              var d = document.createElement("div");
              d.setAttribute("class", "col-4");
              d.setAttribute("style", "padding-bottom:10px");
              var b = document.createElement("button");
              b.setAttribute("type", "button");
              b.setAttribute("class", "btn btn-outline-dark");
              b.setAttribute("onclick", "selezionaOrario('" + orario + "','" + turno.da + "','" + turno.a + "')");
              b.innerHTML = orario;
              d.appendChild(b);
              document.getElementById("bodyOrario").appendChild(d);
            }
          });

          if (!trovato) {
            document.getElementById("lbArrivo").innerHTML = '';
          }


          scroll_to('sceltaorari', 500);


        } else {
          document.getElementById("lbScegliOrari").innerHTML = t("ncsodisp", pp(), "Non ci sono orari disponibili per la tua prenotazione") + '&nbsp;&#x1F622	';
          waitOff();
        }
      }

    }).fail(function (jqxhr, textStatus, error) {
      waitOff();
      if (typeof jqxhr != 'undefined' && typeof jqxhr.responseJSON != 'undefined' && typeof jqxhr.responseJSON.message != 'undefined') {
        errorBox("5 " + t("nrarid", pp(), "Non riesco a recuperare i dati"), jqxhr.responseJSON.message);
      } else {
        errorBox("6 " + t("nrarid", pp(), "Non riesco a recuperare i dati"));
      }
    });
  }, 500);
}

function isTurnoCena(da) {
  var daint;
  if (typeof da === 'string') {
    daint = parseInt(da);
  } else {
    daint = da;
  }
  if (daint >= 17 && daint < 23) {
    return true;
  } else {
    return false;
  }
}


function selezionaDisponibili() {
  waitOn();
  setTimeout(() => {
    //
    var url = wsDisponibili + '?id=' + idLoc + '&day=' + document.getElementById("quando").value + '&quanti=' + quanti + '&cucina=' + cucina;
    console.log(url);
    if (admin) {
      url = url + '&tk=' + replaceAll(Cookies.get("tt_token"), "|", "_");
    }
    $.getJSON(url, function (ris) {
      waitOff();
      risDisponibili = ris;

      if (ris.chiusura) {
        nascondi("lbScegliOrari");
        var divturni = document.getElementById("divorari");
        divturni.innerHTML = "";
        var row = document.createElement("div");
        row.setAttribute("class", "row");
        var turno = document.createElement("div");
        turno.setAttribute("style", "padding: 10px;margin:auto;width:100%");
        var a = document.createElement("div");
        a.setAttribute("style", "font-size:1.25rem;border-style: solid;border-color: black;border-radius: 10px;border-width: 1px;padding: 3px;");
        a.setAttribute("class", "colorBase");
        a.innerHTML = t("locch", pp(), "Il locale in questa data è chiuso") + '&nbsp;<span style="font-size:xx-large">&#128546;</span>';
        a.style.padding = "15px";
        turno.appendChild(a);
        row.appendChild(turno);
        divturni.appendChild(row);
      } else if (ris.disabilitato) {
        waitOff();
        nascondi("lbScegliOrari");
        var divturni = document.getElementById("divorari");
        divturni.innerHTML = "";
        var row = document.createElement("div");
        row.setAttribute("class", "row");
        var turno = document.createElement("div");
        turno.setAttribute("style", "padding: 10px;margin:auto;width:100%");
        var a = document.createElement("div");
        a.setAttribute("style", "font-size:1.25rem;border-style: solid;border-color: black;border-radius: 10px;border-width: 1px;padding: 3px;");
        a.setAttribute("class", "colorBase");
        a.innerHTML = t("disabpreno", pp(), "In questa data il locale è al completo") + '&nbsp;<span style="font-size:xx-large">&#128546;</span>';
        a.style.padding = "15px";
        turno.appendChild(a);
        row.appendChild(turno);
        divturni.appendChild(row);
      } else {
        mostra("lbScegliOrari");
        orari = ris.turni;
        var divturni = document.getElementById("divorari");
        divturni.innerHTML = "";
        if (ris.turni.length > 0) {
          ris.turni = ris.turni.sort(function (a, b) {
            return compareTime(a.da, b.da);
          });
          document.getElementById("lbScegliOrari").innerHTML = t("sc1td", pp(), 'Scegli uno dei turni disponibili');
          ris.turni.forEach(tpt => {
            var row = document.createElement("div");
            row.setAttribute("class", "row");
            var turno = document.createElement("div");
            turno.setAttribute("style", "padding: 10px;margin:auto;width:100%");
            var a = document.createElement("div");
            a.setAttribute("style", "font-size:1.25rem;border-style: solid;border-color: black;border-radius: 10px;border-width: 1px;padding: 3px;cursor:pointer;");
            var idOrario = getNewId();
            a.setAttribute("onclick", "popupOrario('" + tpt.da + "','" + tpt.a + "')");
            if (isTurnoPranzo(tpt.da.split(":")[0], tpt.a.split(":")[0])) {
              a.innerHTML = "<b>" + t("pranzo", pp(), "PRANZO") + "</b><br/>";
            } else if (isTurnoCena(tpt.da.split(":")[0])) {
              a.innerHTML = "<b>" + t("cecna", pp(), "CENA") + "</b><br/>";
            }
            if (tpt.unico) {
              a.innerHTML = a.innerHTML + '<i class="fa fa-sign-in" style="padding-right:7px;color:green;"></i>' + t("locapre", pp(), "Il ristorante apre alle:") + '&nbsp;' + tpt.da + ', ' + t("cucch", pp(), "la cucina chiude alle:") + tpt.a + '<i class="fa fa-sign-out" style="padding-left:7px;color:red"></i>';
            } else {
              a.innerHTML = a.innerHTML + '<i class="fa fa-sign-in" style="padding-right:7px;color:green;"></i>' +
                t("oarrnpd", pp(), "Inizio turno ore :") +
                '&nbsp;' +
                tpt.da + ' - ' +
                t("lascte", pp(), "Fine turno ore :") + '&nbsp;' + tpt.a + '<i class="fa fa-sign-out" style="padding-left:7px;color:red"></i>';
            }
            if (typeof tpt.bagnato !== "undefined" && tpt.bagnato == true) {
              var bagnato = document.createElement("div");
              bagnato.setAttribute("class", "colorBase");
              bagnato.innerHTML = '<div style="font-weight:bold;">' + t("trnRain", pp(), "In questo orario se PIOVE i posti NON SARANNO DISPONIBILI !") + '</div>';
              a.appendChild(bagnato);
            }
            if (typeof tpt.sconto !== "undefined" && parseInt(tpt.sconto) > 0) {
              var sconto = document.createElement("div");
              sconto.setAttribute("class", "colorBase");
              sconto.innerHTML = t("preersc", pp(), "Prenota in questa fascia e ricevi lo sconto del") + '&nbsp;<div style="font-weight:bold;">' + tpt.sconto + '%</div>';
              a.appendChild(sconto);
            } else {
              a.style.padding = "15px";
            }

            turno.appendChild(a);

            row.appendChild(turno);

            divturni.appendChild(row);

            setTimeout(() => {
              scroll_to('nav-ora', 500);
            }, 700);

            waitOff();
          });
        } else {
          document.getElementById("lbScegliOrari").innerHTML = t("ncsodisp", pp(), "Non ci sono orari disponibili per la tua prenotazione") + '&nbsp;&#x1F622	';
          waitOff();
        }
      }

    }).fail(function (jqxhr, textStatus, error) {
      waitOff();
      if (typeof jqxhr != 'undefined' && typeof jqxhr.responseJSON != 'undefined' && typeof jqxhr.responseJSON.message != 'undefined') {
        errorBox("3 " + t("nrarid", pp(), "Non riesco a recuperare i dati"), jqxhr.responseJSON.message);
      } else {
        errorBox("4 " + t("nrarid", pp(), "Non riesco a recuperare i dati"));
      }
    });
  }, 500);
}

function getProssimi() {
  if (document.getElementById("futuri") == null) {
    return;
  }
  waitOn();
  console.log(wsProssimi + '?id=' + idLoc)
  $.getJSON(wsProssimi + '?id=' + idLoc, function (ris) {
    waitOff();
    if (typeof ris != 'undefined' && typeof ris.turni != 'undefined') {
      document.getElementById("prossdisp").innerHTML = t('futdisp', pp(), 'Nei prossimi 7 giorni abbiamo ancora disponibilità per le date seguenti');
      //      
      moment.locale(linguaSelezionata);
      ris.turni.forEach(turno => {
        var nopranzo = false;
        var nocena = false;
        ris.npc.forEach(f => {
          if (f.data === turno.data) {
            if (typeof f.np != 'undefined') {
              nopranzo = true;
            }
            if (typeof f.nc != 'undefined') {
              nocena = true;
            }
          }
        });
        var div = document.createElement("div");
        div.setAttribute("style", "margin: 5px;")
        a = document.createElement("a");
        a.setAttribute("href", "#");
        a.setAttribute("class", "btn btn-outline-dark btn-lg");
        a.setAttribute("style", "padding:5px;overflow: hidden;border-radius: 30px;");
        a.setAttribute("onclick", "btDay('" + turno.data + "')");
        div.appendChild(a);
        var div1 = document.createElement("div");
        div1.style.display = "inline-block";
        div1.style.verticalAlign = "bottom"
        if (!nopranzo) {
          if (turno.pranzo == 1 && turno.cena == 1) {
            div1.innerHTML = a.innerHTML + '<img src="img/svg_icon/lunch.svg" style="width:60px;margin-right:5px;"  />'
          } else if (turno.pranzo == 1) {
            div1.innerHTML = a.innerHTML + '<img src="img/svg_icon/lunch.svg" style="width:60px;margin-right:5px;"  />'
          } else if (turno.cena == 1) {
            div1.innerHTML = a.innerHTML + '<img src="img/svg_icon/nolunch.svg" style="width:60px;margin-right:5px;"  />'
          }
        } else {
          div1.innerHTML = a.innerHTML + '<div style="width:20px;"></div>'
        }
        var div2 = document.createElement("div");
        div2.style.display = "inline-block";
        var g = moment(turno.data, "DD-MM-YYYY");
        if (g.isSame(moment(), 'day')) {
          div2.innerHTML = "<b>" + t('oggi', pp(), 'Oggi') + "</b>";
        } else if (g.isSame(moment().add(1, "day"), 'day')) {
          div2.innerHTML = "<b>" + t('domani', pp(), 'Domani') + "</b>";
        } else {
          div2.innerHTML = "<b>" + g.format("ddd DD MMMM").slice(0, 15) + "</b>";
        }

        if (turno.pranzo == 1 && turno.cena == 1) {
          if (typeof ris.lbl != 'undefined' && typeof ris.lbl.pc != 'undefined') {
            div2.innerHTML = div2.innerHTML + '<br/><span style="font-size:smaller">' + ris.lbl.pc + '</span>'
          } else {
            div2.innerHTML = div2.innerHTML + '<br/><span style="font-size:smaller">' + t('pranzocena', pp(), 'pranzo e cena') + '</span>'
          }
        } else if (turno.pranzo == 1) {
          if (typeof ris.lbl != 'undefined' && typeof ris.lbl.sp != 'undefined') {
            div2.innerHTML = div2.innerHTML + '<br/><span style="font-size:smaller">' + ris.lbl.sp + '</span>'
          } else {
            div2.innerHTML = div2.innerHTML + '<br/><span style="font-size:smaller">' + t('solopranzo', pp(), 'solo pranzo') + '</span>'
          }
        } else if (turno.cena == 1) {
          if (typeof ris.lbl != 'undefined' && typeof ris.lbl.sp != 'undefined') {
            div2.innerHTML = div2.innerHTML + '<br/><span style="font-size:smaller">' + ris.lbl.sc + '</span>'
          } else {
            div2.innerHTML = div2.innerHTML + '<br/><span style="font-size:smaller">' + t('solocena', pp(), 'solo cena') + '</span>'
          }
        }

        var div3 = document.createElement("div");
        div3.style.display = "inline-block";
        div3.style.verticalAlign = "bottom"
        if (!nocena) {
          if (turno.pranzo == 1 && turno.cena == 1) {
            div3.innerHTML = a.innerHTML + '<img src="img/svg_icon/dinner.svg" style="width:60px;margin-left:5px;"  />'
          } else if (turno.pranzo == 1) {
            div3.innerHTML = a.innerHTML + '<img src="img/svg_icon/nodinner.svg" style="width:60px;margin-left:5px;"  />'
          } else if (turno.cena == 1) {
            div3.innerHTML = a.innerHTML + '<img src="img/svg_icon/dinner.svg" style="width:60px;margin-left:5px;"  />'
          }
        } else {
          div3.innerHTML = a.innerHTML + '<div style="width:20px;"></div>'
        }

        a.appendChild(div1);
        a.appendChild(div2);
        a.appendChild(div3);
        document.getElementById("futuri").appendChild(div);
      });
    } else {
      document.getElementById("prossdisp").innerHTML = t('futnodisp', pp(), 'Nei prossimi 7 giorni non abbiamo disponibilità');
    }
    nascondi("loading");
  }).fail(function (jqxhr, textStatus, error) {
    waitOff();
    if (typeof jqxhr != 'undefined' && typeof jqxhr.responseJSON != 'undefined' && typeof jqxhr.responseJSON.message != 'undefined') {
      errorBox("1 " + t("nrarid", pp(), "Non riesco a recuperare i dati"), jqxhr.responseJSON.message);
    } else {
      errorBox("2 " + t("nrarid", pp(), "Non riesco a recuperare i dati"));
    }
  });
}

function getInfo() {
  waitOn();
  var url;
  
  if (typeof pwd != 'undefined') {
    url = wsGetInfo + '?p=' + pwd    
    $.getJSON(url, function (ris) {      
      waitOff();
      if (ris.locale != null) {
        document.getElementById("nomelocale").innerHTML = ris.locale;
      }
      if (ris.indirizzo != null || ris.citta!=null) {
        var indirizzo="";
        var google="";
        if (ris.citta!=null){
          indirizzo = ris.citta;
          google = ris.citta;
        }
        if (ris.indirizzo!=null){
          indirizzo = indirizzo + "<br/>" + ris.indirizzo;
          google = google + " " + ris.indirizzo;
        }
        document.getElementById("indirizzolocale").innerHTML = indirizzo + '<a target="_blank" href="http://maps.google.com/maps?q=' + encodeURI(google) + '"><i style="padding-left:10px;color:red;cursor:pointer;" class="fa fa-map-marker" aria-hidden="true"></i></a>';
      }
      if (typeof ris.cucina1 !== "undefined") {
        cucina1 = ris.cucina1
      }
      if (typeof ris.cucina2 !== "undefined") {
        cucina2 = ris.cucina2
      }
      if (typeof ris.maxquanti !== "undefined") {
        maxQuanti = ris.maxquanti
      }
      if (!ris.enabled) {
        errorBox(t("sistnonab", pp(), "Il sistema di prenotazione al momento non è abilitato"));
        nascondi("divprenota");
      }

      if (typeof ris.waserver != 'undefined') {
        waserver = true;
        mostra("confDesktop");
      }

      //
      if (Cookies.get("tt_offerta") != null) {
        if (typeof offerta.BOOKED != 'undefined') {
          setTimeout(() => {
            Cookies.remove('tt_offerta');
            offerta = undefined;
          }, 5000);
          moment.locale(linguaSelezionata)
          var d = moment(offerta.BOOKED, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm')
          document.getElementById("div_offerta").innerHTML = t("offcons", pp(), "L'offerta è già stata consumata in data :") + " " + d
        } else {
          var valida = true;
          if (typeof offerta.VALID != 'undefined') {
            var v = moment(offerta.VALID, "DD/MM/YYYY");
            v.add(1, 'days');
            //
            //
            if (moment().isAfter(v)) {
              valida = false;
            }
          }
          if (valida) {
            document.getElementById("tit_offerta").innerHTML = offerta.TIT
            document.getElementById("desc_offerta").innerHTML = offerta.DESC
          } else {
            Cookies.remove('tt_offerta');
            offerta = undefined;
            document.getElementById("div_offerta").innerHTML = t("offscad", pp(), "L'offerta  selezionata non è più valida")
          }
        }
        mostra("div_offerta")
      }
    });
  } else {    
    waitOff();
    errorBox(t("nrarid", pp(), "Non riesco a recuperare i dati"));
  }
}

function getNewId() {
  var tempo = new Date().getTime();
  return baseConvert(idLoc + "|" + tempo, "123456789", "abcdefghijkmnpqrstuvwxyz123456789");
}

function getToken() {
  var tempo = new Date().getTime();
  return idLoc + "|" + tempo + "|" + md5(idLoc + 'tabletake' + tempo);
}

function scegliOrarioSimple() {
  if (document.getElementById("quando").value != '' && quanti > 0) {
    var orarioArrivo = document.getElementById("lbArrivo").innerHTML;


    orario = turnoScelto;
    orario.id = getNewId();
    orario.token = getToken();
    orario.verified = false;
    orario.idloc = idLoc;
    orario.quanti = quanti;
    orario.data = document.getElementById("quando").value;
    orario.da = orarioArrivo;
    document.getElementById("testosms").innerHTML = 'tt' + '<div class="backgBase" style="border-style: solid;border-color: black;border-width: 1px;display: inline;margin: 5px;">&nbsp;&nbsp;</div>' + orario.id;
    document.getElementById("hrefwaweb").setAttribute("href", "https://web.whatsapp.com/send?phone=+393277162771&text=" + encodeURI(t("confprenot", pp(), "Confermo la prenotazione con codice :")) + encodeURI(' tt ' + orario.id));

    //console.log(orario);
    mostra("divnote");
    mostra("divnota");
    mostra("divcrea");
    nascondi("divsms");
    scroll_to('txtnome', 500);
    document.getElementById("txtnome").focus();
  }
}


function scegliOrario() {
  if (document.getElementById("quando").value != '' && quanti > 0) {
    var orarioArrivo = document.getElementById("lbArrivo").innerHTML;
    var da = document.getElementById("lbDa").innerHTML;
    var a = document.getElementById("lbA").innerHTML;

    document.getElementById("nav-ora-tab").innerHTML = orarioArrivo + '-' + a;

    orari.forEach(o => {
      if (o.da == da && o.a == a) {
        orario = o;
        orario.id = getNewId();
        orario.token = getToken();
        orario.verified = false;
        orario.idloc = idLoc;
        orario.quanti = quanti;
        orario.data = document.getElementById("quando").value;
        orario.da = orarioArrivo;
        document.getElementById("testosms").innerHTML = 'tt' + '<div class="backgBase" style="border-style: solid;border-color: black;border-width: 1px;display: inline;margin: 5px;">&nbsp;&nbsp;</div>' + orario.id;
        document.getElementById("hrefwaweb").setAttribute("href", "https://web.whatsapp.com/send?phone=+393277162771&text=" + encodeURI(t("confprenot", pp(), "Confermo la prenotazione con codice :")) + encodeURI(' tt ' + orario.id));

      }
    });
    document.getElementById("nav-prenota").style.visibility = 'visible';
    $("#nav-prenota-tab").removeClass("disabled");
    mostra('nav-prenota-tab');
    $('#nav-prenota-tab').tab('show');
    mostra("divnota");
    if (admin) {
      document.getElementById("btConferma").innerHTML = "Inserisci prenotazione";
      mostra("adminTelefono")
    }
    mostra("divcrea");
    nascondi("divsms");
  }
}

function allertsms() {
  alert(t("dairqp", pp(), 'Dopo aver inviato il messaggio ritorna su questa pagina per attendere la conferma di ricezione'));
  return true;
}

function allerttgram() {
  alert(t("qsatpa", pp(), 'Quando si apre Telegram premi il bottone "Avvia"'));
  return true;
}

function allertwa() {
  //if(new MobileDetect(window.navigator.userAgent).mobile()) {
  $('#istruzioniWa').modal('show');
  //  } else {
  //  errorBox("Funzione abilitata solo su dispositivi mobili");
  //}
}

function procediWa() {
  //if(new MobileDetect(window.navigator.userAgent).mobile()) {
  $('#istruzioniWa').modal('hide');
  window.open('https://wa.me/+393277162771?text=' + t("confprenot", pp(), "Confermo la prenotazione con codice :") + ' tt ' + orario.id);
  //}
}

function copiaTesto(txt) {
  if (copyToClipboard(txt)) {
    $.notify(t("tcna", pp(), "Testo copiato negli appunti"), "success");
  }
}

function tranquillizza() {
  if (idLoc == 1 || idLoc == 16) {
    messageBox(t("nb", pp(), "NOTA BENE"), t('demonopaura', pp(), 'Siamo in modalità dimostrativa, il tuo numero non apparirà, puoi procedere tranquillamente'), scrollaConferma);
  }
}

function scrollaConferma() {
  setTimeout(() => {
    scroll_to('nav-conferma', 500);
  }, 700);
}

function clickProvaTelefonino() {
  if (getBaseColor().includes('EA4D3F')) {
    messageBox(t("istruzioni", pp(), "ISTRUZIONI"), t('vaisultel', pp(), 'Prendi il tuo telefonino e naviga su : ') + '<b>prenota.foodappy.it/test</b>');
  } else {
    messageBox(t("istruzioni", pp(), "ISTRUZIONI"), t('vaisultel', pp(), 'Prendi il tuo telefonino e naviga su : ') + '<b>app.tabletake.it/test</b>');
  }
}

function msgDesktop() {

  if (!iti.isValidNumber()) {

    errorBox(t("attenzione", pp(), "ATTENZIONE"), t("novalnum", pp(), "Il numero di telefono inserito non è valido"));
    return;

  } else if (iti.getNumberType() != 1) {

    errorBox(t("attenzione", pp(), "ATTENZIONE"), t("nomobnum", pp(), "Il numero inserito non è di un telefono mobile che può avere WhatsApp"));
    return;

  } else {

    if (typeof orario === "undefined") {
      errorBox(t("avverrdp", pp(), "Avvenuti errori durante la registrazione della prenotazione... Riprova"));
      return;
    } else {
      orario.phone = iti.getNumber();
      waitOn();
      setTimeout(() => {
        $.ajax({
          type: "POST",
          url: wsConfermaDesktop,
          data: JSON.stringify(orario),
          dataType: "text",
          success: function (data, status, jQxhr) {

            waitOff();
            if (status === 'success') {
              messageBox("&#128515;", t("okdeskconf", pp(), "Prenotazione inserita.<br/>Controlla il tuo WhatsApp per confermare"));
            } else {

              errorBox(t("avverrdp", pp(), "Avvenuti errori durante la registrazione della prenotazione... Riprova"));
            }
          },
          error: function (jqXhr, textStatus, errorThrown) {
            waitOff();;
          }
        });
      }, 500);
    }

  }
}

function confermaPrenotazioneSimple() {

  if (typeof orario === "undefined") {
    errorBox(t("avverrdp", pp(), "Avvenuti errori durante la registrazione della prenotazione... Riprova"));
    return;
  } else {
    if (document.getElementById("txtnome").value.trim() != '') {
      if (document.getElementById("txtnome").value.length < 4) {
        errorBox(t("datiinc", pp(), "Dati incompleti"), t("nomtrc", pp(), "Il tuo nome mi sembra troppo corto"))
        return;
      }
      var note = {};
      note.nome = document.getElementById("txtnome").value;
      if (document.getElementById("txtnote").value != '') {
        note.note = document.getElementById("txtnote").value;
      }

      note.rai = false
      orario.note = JSON.stringify(note);

    } else {
      errorBox(t("datmanc", pp(), "Dati mancanti"), t("insnomdl", pp(), "Inserisci il nome da legare alla prenotazione"))
      return;
    }


    //    
    waitOn();
    setTimeout(() => {
      orario.lang = linguaSelezionata;
      if (typeof offerta != 'undefined') {
        orario.offerta = JSON.stringify(offerta);
      }
      //console.log(JSON.stringify(orario))
      $.ajax({
        type: "POST",
        url: wsAddPrenotazione,
        data: JSON.stringify(orario),
        dataType: "json",
        success: function (data, status, jQxhr) {
          if (status === 'success') {
            waitOff();

            if (typeof offerta != 'undefined') {
              Cookies.remove('tt_offerta');
              offerta = undefined;
            }

            var data = moment(orario.data, "DD-MM-YYYY");;
            var oggi = moment();
            var diff = data.diff(oggi, 'days') + 2;
            for (let i = 0; i < 20; i++) {
              if (typeof Cookies.get('pr_' + idLoc + "_" + i) === "undefined") {
                Cookies.set('pr_' + idLoc + "_" + i, JSON.stringify(orario), {
                  expires: diff
                });
                break;
              } else {
                var p = JSON.parse(Cookies.get('pr_' + idLoc + "_" + i));
                if (p.da === orario.da && p.a === orario.a && p.data === orario.data) {
                  Cookies.set('pr_' + idLoc + "_" + i, JSON.stringify(orario), {
                    expires: diff
                  });
                  break;
                }
              }
            }

            scriviAllert();

            erroriArrivo = 0;
            setTimeout(() => {
              attendiConferma();
            }, 5000);

            mostra("divconferma");
            mostra("divsms");


            if (new MobileDetect(window.navigator.userAgent).mobile() != null) {
              mostraInLineFlex("onlymobile");
              nascondi("onlysms");
              document.getElementById("atelegram").setAttribute("href", "https://telegram.me/tabletake_bot?start=tt" + orario.id);
              document.getElementById("asms").setAttribute("href", "sms:+393665860580?body=" + encodeURI("tt ") + orario.id);
              var link = new SMSLink.link();
              link.replaceAll();
            } else {
              nascondi("onlymobile");
              mostra("onlysms");
            }

            scroll_to('divsms', 500);



          } else {
            waitOff();

            errorBox(t("avverrdp", pp(), "Avvenuti errori durante la registrazione della prenotazione... Riprova"));
          }

        },
        error: function (jqXhr, textStatus, errorThrown) {
          waitOff();


        }
      });
    }, 500);
  }

}

function confermaPrenotazione() {

  if (admin) {
    if (document.getElementById("txtCellConf").value === '') {
      errorBox("TELEFONO MANCANTE", "Indica un cellulare per la conferma WhatsApp");
      return;
    }
  }

  if (typeof orario === "undefined") {
    errorBox(t("avverrdp", pp(), "Avvenuti errori durante la registrazione della prenotazione... Riprova"));
    return;
  } else {
    if (document.getElementById("txtnome").value.trim() != '') {
      if (document.getElementById("txtnome").value.length < 4) {
        errorBox(t("datiinc", pp(), "Dati incompleti"), t("nomtrc", pp(), "Il tuo nome mi sembra troppo corto"))
        return;
      }
      var note = {};
      note.nome = document.getElementById("txtnome").value;
      if (document.getElementById("txtnote").value != '') {
        note.note = document.getElementById("txtnote").value;
      }
      if (bagnato) {
        note.rai = true
      } else {
        note.rai = false
      }
      orario.note = JSON.stringify(note);
    } else {
      errorBox(t("datmanc", pp(), "Dati mancanti"), t("insnomdl", pp(), "Inserisci il nome da legare alla prenotazione"))
      return;
    }

    if (admin) {
      orario.token = Cookies.get("tt_token");
      orario.phone = document.getElementById("txtCellConf").value
    }

    //    
    waitOn();
    setTimeout(() => {
      orario.lang = linguaSelezionata;
      if (typeof offerta != 'undefined') {
        orario.offerta = JSON.stringify(offerta);
      }
      $.ajax({
        type: "POST",
        url: wsAddPrenotazione,
        data: JSON.stringify(orario),
        dataType: "json",
        success: function (data, status, jQxhr) {
          if (status === 'success') {
            waitOff();

            if (typeof offerta != 'undefined') {
              Cookies.remove('tt_offerta');
              offerta = undefined;
            }

            if (!admin) {

              var data = moment(orario.data, "DD-MM-YYYY");;
              var oggi = moment();
              var diff = data.diff(oggi, 'days') + 2;
              for (let i = 0; i < 20; i++) {
                if (typeof Cookies.get('pr_' + idLoc + "_" + i) === "undefined") {
                  Cookies.set('pr_' + idLoc + "_" + i, JSON.stringify(orario), {
                    expires: diff
                  });
                  break;
                } else {
                  var p = JSON.parse(Cookies.get('pr_' + idLoc + "_" + i));
                  if (p.da === orario.da && p.a === orario.a && p.data === orario.data) {
                    Cookies.set('pr_' + idLoc + "_" + i, JSON.stringify(orario), {
                      expires: diff
                    });
                    break;
                  }
                }
              }

              scriviAllert();

              erroriArrivo = 0;
              setTimeout(() => {
                attendiConferma();
              }, 5000);

              nascondi("divnota");
              nascondi("divcrea");
              document.getElementById("nav-conferma").style.visibility = 'visible';
              $("#nav-conferma-tab").removeClass("disabled");
              mostra("nav-conferma-tab");
              $('#nav-conferma-tab').tab('show');
              mostra("divsms");
              if (new MobileDetect(window.navigator.userAgent).mobile() != null) {
                mostraInLineFlex("onlymobile");
                nascondi("onlysms");
                document.getElementById("atelegram").setAttribute("href", "https://telegram.me/tabletake_bot?start=tt" + orario.id);
                document.getElementById("asms").setAttribute("href", "sms:+393665860580?body=" + encodeURI("tt ") + orario.id);
                var link = new SMSLink.link();
                link.replaceAll();
                setTimeout(() => {
                  scroll_to('onlymobile', 200);  
                }, 600);
                
              } else {
                nascondi("onlymobile");
                mostra("onlysms");
              }              
              setTimeout(() => {
                messageBox(t("atz", pp(), "ATTENZIONE"), t('msgsys', pp(), 'Abbiamo quasi finito ! Per rendere valida la tua prenotazione e ricevere conferma invia un messaggio al sistema.'), tranquillizza);  
              }, 700);                                         
            } else {
              messageBox("&#128515;", "Prenotazione inserita", function () {
                location.reload()
              });
            }

          } else {
            waitOff();

            errorBox(t("avverrdp", pp(), "Avvenuti errori durante la registrazione della prenotazione... Riprova"));
          }

        },
        error: function (jqXhr, textStatus, errorThrown) {
          waitOff();


        }
      });
    }, 500);
  }

}

function aggiornaStato(p, i) {
  $.getJSON(wsGetStato + '?id=' + p.id, function (ris) {

    p.updated = true;
    if (ris.arrv == true) {
      p.confirmed = ris.conf;
      p.verified = ris.verf;
      if (typeof ris.err !== "undefined") {
        p.err = ris.err;
      }
      var data = moment(p.data, "DD-MM-YYYY");;
      var oggi = moment();
      var diff = data.diff(oggi, 'days') + 2;
      Cookies.set('pr_' + idLoc + "_" + i, JSON.stringify(p), {
        expires: diff
      });
    } else {

      Cookies.remove('pr_' + idLoc + "_" + i);
    }
  });
}

function updatePrenotazioni() {
  for (let j = 0; j < 20; j++) {
    if (typeof Cookies.get('pr_' + idLoc + "_" + j) != "undefined") {
      var pp = JSON.parse(Cookies.get('pr_' + idLoc + "_" + j));
      if (moment(pp.data + " " + pp.da, "DD-MM-YYYY hh:mm").fromNow().indexOf("ago") == -1) {
        pp.updated = false;
        aggiornaStato(pp, j);
      } else {
        Cookies.remove('pr_' + idLoc + "_" + j)
      }
    }
  }
  setTimeout(() => {
    fineUpdate();
  }, 3000);
}

function fineUpdate() {
  var finito = true;
  for (let j = 0; j < 20; j++) {
    if (typeof Cookies.get('pr_' + idLoc + "_" + j) != "undefined") {
      var pp = JSON.parse(Cookies.get('pr_' + idLoc + "_" + j));
      if (!pp.updated) {
        finito = false;
      }
    }
  }
  if (finito) {
    scriviAllert();
  } else {

    setTimeout(() => {
      fineUpdate();
    }, 3000);
  }
}

function attendiConferma() {
  $.getJSON(wsGetStato + '?id=' + orario.id, function (ris) {
    erroriArrivo++;
    if (!ris.arrv) {

      if (erroriArrivo >= 10) {
        errorBox(t("errore", pp(), "ERRORE"), t("rippren", pp(), "Ripeti la prenotazione"));
      } else {
        setTimeout(() => {
          attendiConferma();
        }, 5000);
      }
    } else {
      if (ris.verf || (typeof ris.err !== "undefined")) {

        for (let i = 0; i < 20; i++) {
          if (typeof Cookies.get('pr_' + idLoc + "_" + i) != "undefined") {
            var p = JSON.parse(Cookies.get('pr_' + idLoc + "_" + i));
            if (p.id === orario.id) {
              if (typeof ris.err === "undefined") {
                p.verified = true;
              } else {
                p.err = ris.err;
              }
              p.confirmed = ris.conf;
              var data = moment(p.data, "DD-MM-YYYY");;
              var oggi = moment();
              var diff = data.diff(oggi, 'days') + 2;
              Cookies.set('pr_' + idLoc + "_" + i, JSON.stringify(p), {
                expires: diff
              });
            }
          }
        }
        scriviAllert();

        if (idLoc == 1 || idLoc == 16) {
          $.confirm({
            title: t("prenverif", pp(), 'PRENOTAZIONE VERIFICATA'),
            content: t("vvcsnt", pp(), 'Vuoi vedere cosa è successo sul tabellone ?'),
            boxWidth: new MobileDetect(window.navigator.userAgent).mobile() != null ? '90%' : '50%',
            useBootstrap: false,
            buttons: {
              confirm: {
                btnClass: 'btn-green',
                text: t("opentab", pp(), 'Apri Tabellone'),
                action: function () {
                  demoTabellone();
                }
              },
              cancel: {
                btnClass: 'btn-BLU', // multiple classes.
                text: t("restaqui", pp(), 'Resta qui'),
                action: function () {
                  //
                }
              }
            }
          });

        } else {
          if (typeof ris.err === "undefined") {
            messageBox("OK !", t("tuttoabf", pp(), "Tutto è andato a buon fine e la tua prenotazione è stata presa in carico"));
            nascondi("divprenota")
          } else {
            if (ris.err === 'busy') {
              errorBox(t("attenzione", pp(), "ATTENZIONE"), t("ltpsr", pp(), "La tua prenotazione è stata rifiutata, i tavoli non sono più disponibili"));
            } else {
              errorBox(t("attenzione", pp(), "ATTENZIONE"), t("ltpef", pp(), "La tua prenotazione è fallita, avvenuti errori di sistema"));
            }
          }

        }

      } else {

        if (erroriArrivo < 15) {
          setTimeout(() => {
            attendiConferma();
          }, 20000);
        }
      }
    }
  });
}

function scriviAllert() {
  if (typeof idLoc !== "undefined") {
    var trovata = false;
    var txt = document.getElementById("txtallert");
    for (let i = 0; i < 20; i++) {
      if (typeof Cookies.get('pr_' + idLoc + "_" + i) != "undefined") {
        var p = JSON.parse(Cookies.get('pr_' + idLoc + "_" + i));
        if (moment(p.data + " " + p.da, "DD-MM-YYYY hh:mm").fromNow().indexOf("ago") == -1) {
          trovata = true;
          var ul = document.createElement("ul");
          txt.innerHTML = '';
          document.getElementById("divallert").setAttribute("class", "alert alert-secondary");
          ul.setAttribute("class", "unordered-list");
          ul.setAttribute("id", "lstallert");
          txt.appendChild(ul);
          break;
        }
      }
    }

    for (let i = 0; i < 20; i++) {
      if (typeof Cookies.get('pr_' + idLoc + "_" + i) != "undefined") {
        var p = JSON.parse(Cookies.get('pr_' + idLoc + "_" + i));
        // mostro solo quelle non passate
        if (moment(p.data + " " + p.da, "DD-MM-YYYY hh:mm").fromNow().indexOf("ago") == -1) {
          var li = document.createElement("li");
          if (p.verified == true && p.confirmed == true) {
            li.innerHTML = '<span style="font-weight:bold;">Confermata</span> giorno ' + replaceAll(p.data, "-", "/") + ' - dalle ' + p.da + ' alle ' + p.a + ' - ' + p.quanti + ' persone';
            document.getElementById("lstallert").appendChild(li);
          } else if (p.verified == true && p.confirmed == false) {
            li.innerHTML = '<span style="font-weight:bold;">Ricevuta</span> giorno ' + replaceAll(p.data, "-", "/") + ' - dalle ' + p.da + ' alle ' + p.a + ' - ' + p.quanti + ' persone';
            document.getElementById("lstallert").appendChild(li);
          } else if (p.verified == false) {
            if (typeof p.err !== "undefined") {
              document.getElementById("divallert").setAttribute("class", "alert alert-danger");
              if (p.err === 'busy') {
                li.innerHTML = '<span style="font-weight:bold;">' + t("ncnpd", pp(), "Non confermata ! Tavoli non più disponibili") + '&nbsp;</span>&nbsp;' + t("giorno", pp(), "giorno") + '&nbsp;' + replaceAll(p.data, "-", "/") + ' -&nbsp;' + t("dalle", pp(), "dalle") + '&nbsp;' + p.da + '&nbsp;' + t("alle", pp(), "alle ore") + '&nbsp;' + p.a + ' - ' + p.quanti + '&nbsp;' + t("persone", pp(), "persone");
                document.getElementById("lstallert").appendChild(li);
              } else {
                li.innerHTML = '<span style="font-weight:bold;">' + t("ncerrsis", pp(), "Non Confermata ! Errore di sistema") + '</span>&nbsp;' + t("giorno", pp(), "giorno") + '&nbsp;' + replaceAll(p.data, "-", "/") + ' -&nbsp;' + t("dalle", pp(), "dalle") + '&nbsp;' + p.da + '&nbsp;' + t("alle", pp(), "alle ore") + '&nbsp;' + p.a + ' - ' + p.quanti + '&nbsp;' + t("persone", pp(), "persone");
                document.getElementById("lstallert").appendChild(li);
              }
            } else {
              document.getElementById("divallert").setAttribute("class", "alert alert-warning");
              li.innerHTML = '<span style="font-weight:bold;">' + t("inasms", pp(), "In attesa di SMS") + '</span>&nbsp;' + t("giorno", pp(), "giorno") + '&nbsp;' + replaceAll(p.data, "-", "/") + ' -&nbsp;' + t("dalle", pp(), "dalle") + '&nbsp;' + p.da + '&nbsp;' + t("alle", pp(), "alle ore") + '&nbsp;' + p.a + ' - ' + p.quanti + '&nbsp;' + t("persone", pp(), "persone");
              document.getElementById("lstallert").appendChild(li);
            }
          }
        }
      }
    }
    txt.innerHTML = txt.innerHTML + "</ul>";
  }

  if (trovata == true) {
    mostra("divallert");
  } else {
    nascondi("divallert");
  }
}

function demoTabellone() {
  waitOn();
  var url;

  if (getBaseColor().includes('EA4D3F')) {
    url = wsGetToken + "?id=16";
  } else {
    url = wsGetToken + "?id=1";
  }
  $.getJSON(url, function (ris) {
    waitOff();
    Cookies.set('tt_token', ris.token, {
      expires: 0.5
    });
    Cookies.set('tt_provider', 'google', {
      expires: 0.5
    });
    /** bugsnag */
    if (typeof bugsnagClient != 'undefined') {
      bugsnagClient.user = {
        id: typeof token !== "undefined" ? token.split("|")[0] : ""
      }
    }
    window.location = 'tabellone.html';
  });
}

function pubblicaSezione(page, target, callback) {
  $.get(page, '', function (data) {
    if (typeof target != 'undefined') {
      $(target).append(data);
    }
    if (typeof callback !== "undefined") {
      callback();
    }
  });
}

function postFooter() {
  var a = document.getElementById("refauthor");
  a.setAttribute("href", "https://" + window.location.hostname);
  a.innerHTML = "&copy;TableTake"
}

/*************************** ricerca logo ************************************ */

function fileAwsExist(album, name, callback, failback) {

  var xhr = new XMLHttpRequest();
  xhr.open("HEAD", "https://app.tabletake.it/loghi/" + name, true);
  xhr.setRequestHeader('Content-Type', 'text/plain');
  xhr.onload = function (e) {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        if (callback != undefined) {
          callback();
        }
      } else {
        if (failback != undefined) {
          failback();
        }
      }
    }
  };
  xhr.onerror = function (e) {
    if (failback != undefined) {
      failback();
    }
  };
  xhr.send(null);

}

function celogo(tipo) {
  if (document.getElementById("imglogo") != null) {
    document.getElementById("imglogo").setAttribute("src", "https://app.tabletake.it/loghi/" + idLoc + "." + tipo);
  }
}

function noncelogo(tipo) {
  /*if (tipo === 'jpg') {
    fileAwsExist("loghi", idLoc + ".jpeg", celogo.bind(null, 'jpeg'), noncelogo.bind(null, 'jpeg'));
  } else if (tipo === 'jpeg') {
    fileAwsExist("loghi", idLoc + ".png", celogo.bind(null, 'png'), noncelogo.bind(null, 'png'));
  } else if (tipo === 'png') {
    fileAwsExist("loghi", idLoc + ".gif", celogo.bind(null, 'gif'), noncelogo.bind(null, 'gif'));
  } else {
  }*/
}

function cercaLogo() {
  fileAwsExist("loghi", idLoc + ".jpg", celogo.bind(null, 'jpg'), noncelogo.bind(null, 'jpg'));
  fileAwsExist("loghi", idLoc + ".png", celogo.bind(null, 'png'), noncelogo.bind(null, 'jpg'));
}

function getAdminParam() {
  if (token != null && (token.startsWith("16|") || token.startsWith("1|"))) {
    return "?admin=true"
  } else {
    return "";
  }
}

function vaiHome() {
  if (getBaseColor().includes('FF008C')) {
    location = 'index.html';
  } else if (getBaseColor().includes('EA4D3F')) {
    location = 'loginfa.html';
  } else {
    location = 'index.html';
  }
}

function caricaDati() {

  waitOff();

  getInfo();

  getProssimi();

  updatePrenotazioni();

  if (idLoc !== '1' && idLoc !== '16') {
    cercaLogo();
  } else {
    mostra('divdemo');
    mostra('nonfermarti');
    mostra('esconferma');
    document.getElementById("imglogo").setAttribute("src", "img/tuologo.svg");
  }

}

function caricaDaOfferta(off) {
  $.getJSON(wsGetOfferta + '?off=' + off, function (ris) {    
    Cookies.set('ttid', ris.ID_LOC, {
      expires: 0.5
    });
    idLoc = ris.ID_LOC;
    if (typeof ris.P != 'undefined') {
      Cookies.set('ttpwd', ris.P, {
        expires: 0.5
      });
      pwd = ris.P;
    }
    Cookies.set('tt_offerta', ris, {
      expires: 0.1
    });
    offerta = ris;
    //location = "prenota.html";
  }).fail(function (jqxhr, textStatus, error) {
    waitOff();
    if (typeof jqxhr != 'undefined' && typeof jqxhr.responseJSON != 'undefined' && typeof jqxhr.responseJSON.message != 'undefined') {
      errorBox(t("nraridoff", pp(), "Non riesco a recuperare i dati dell'offerta"), jqxhr.responseJSON.message);
    } else {
      errorBox(t("nraridoff", pp(), "Non riesco a recuperare i dati dell'offerta"));
    }
  });
}

/*************************** fine ricerca logo ******************************** */


(function ($) {
  "use strict";

  $(document).ready(function () {

    //t("prembtconf", pp(), "PREMI IL BOTTONE E TRASMETTI IL TUO NUMERO DI TELEFONO PER COMPLETARE LA PRENOTAZIONE");

    if (getHttpGetParameterByName('off') != null) {
      caricaDaOfferta(getHttpGetParameterByName('off'));
    }

    if (document.getElementById("hreflogo") != null) {
      if (getHttpGetParameterByName('from') != null) {

        document.getElementById("hreflogo").setAttribute("href", getHttpGetParameterByName('from'));
      }
    }

    if (typeof Cookies.get("ttid") !== "undefined") {      
      idLoc = Cookies.get("ttid");      
    } else if (getHttpGetParameterByName('id') != null) {
      idLoc = getHttpGetParameterByName('id');
    }

    if (typeof Cookies.get("ttpwd") !== "undefined") {
      pwd = Cookies.get("ttpwd");
    } else if (getHttpGetParameterByName('pwd') != null) {
      pwd = getHttpGetParameterByName('pwd');
    }

    if (idLoc != null) {
      caricaDati()
    } else {
      if (Cookies.get("tt_token") != null) {

        $.getJSON(wsIsValidToken + '?tk=' + replaceAll(Cookies.get("tt_token"), "|", "_"), function (ris) {

          if (ris.valid == true) {
            idLoc = Cookies.get("tt_token").split('|')[0]
            caricaDati();
            admin = true;
            if (document.getElementById("hreflogo") != null) {
              document.getElementById("hreflogo").setAttribute("href", "tabellone.html");
              document.getElementById("hrefhome").setAttribute("href", "tabellone.html");
              document.getElementById("hrefhome2").setAttribute("href", "tabellone.html");
            }
          } else {
            vaiHome();
          }

        });

      } else {

        vaiHome();

      }
    }

    pubblicaSezione('bottomfooter.html', document.getElementById("bottomfooter"), postFooter);

    if (new MobileDetect(window.navigator.userAgent).mobile() == null) {

      mostra("seiDesktop");
      if (idLoc === '1' || idLoc === '16') {
        mostra('divdemo2');
        mostra('divmesegratis');
      }
    } else {

      if (idLoc === '1' || idLoc === '16') {
        mostra('divmesegratis');
      }
    }

    const theMaxDate = moment().add('days', 90);

    if (document.getElementById("pignosecalender") != null) {


      $('#pignosecalender').pignoseCalendar({

        // en, ko, fr, ch, de, jp, pt, fr
        lang: linguaSelezionata,

        // You can change auto initialized date at first.
        date: moment(),

        // light, dark
        theme: 'light',

        // date format
        format: 'DD-MM-YYYY',

        // CSS class array
        classOnDays: [],

        // array of enabled dates
        enabledDates: [],

        // disabled dates
        disabledDates: [],

        // You can disable by using a weekday number array (This is a sequential number start from 0 [sunday]).
        disabledWeekdays: [],

        // This option is advanced way to using disable settings, You can give multiple disabled range by double array date string by formatted to 'YYYY-MM-DD'.
        disabledRanges: [],

        // Set and array of events to pin on calendar. 
        // Each event is an object that must contain a date string formatted to 'YYYY-MM-DD' and class key that belong to classOnEvents dictionary indicating its color on calendar. 
        // Events with not color class suitable are all pin with  #5c6270. 
        // Issues may arise when the number of color class increase, this could break the calendar cell.
        schedules: [],

        // Set a dictionary with class 'key' and color code 'value' used for pin events class by date.
        scheduleOptions: {
          colors: {}
        },

        // Your first day of week (0: Sunday ~ 6: Saturday).
        week: 0,

        // If you set true this option, You can use multiple range picker by one click on your Calendar.
        pickWeeks: false,

        //  You can turn on/off initialized date by this option.
        initialize: true,

        // enable multiple date selection
        multiple: false,

        // use toggle in the calendar
        toggle: false,

        // shows buttons
        buttons: false,

        // reverse mode
        reverse: false,

        // display calendar as modal
        modal: false,

        // add button controller for confirm by user
        buttons: false,

        // minimum disable date range by 'YYYY-MM-DD' formatted string
        minDate: moment().subtract(1, 'day'),

        // maximum disable date range by 'YYYY-MM-DD' formatted string
        maxDate: null,

        // called when you select a date on calendar (date click).
        select: scegliData,

        // If you set true this option, You can pass the check of disabled dates when multiple mode enabled.
        selectOver: false,

        // called when you apply a date on calendar. (OK button click).
        apply: null,

        // called when you apply a date on calendar. (OK button click).
        click: null

      });
    } else {


      $('#quando').bootstrapMaterialDatePicker({
        weekStart: 1,
        time: false,
        format: 'DD-MM-YYYY',
        cancelText: 'Annulla',
        minDate: moment().add(7, "days"),
        maxDate: theMaxDate,
        switchOnClick: true,
        lang: linguaSelezionata
      });

      $('#quando').change(function () {
        cambiaData();
      });

    }

    function scegliData(e) {
      document.getElementById("quando").value = e[0].format("DD-MM-YYYY");
      document.getElementById("dataArrivo").innerHTML = e[0].format("DD/MM/YYYY");
      mostra("sceltaquanti");
      creaBottoniQuanti();
      scroll_to('sceltaquanti', 500);
    }

    // mobile_menu
    var menu = $('ul#navigation');
    if (menu.length) {
      menu.slicknav({
        prependTo: ".mobile_menu",
        closedSymbol: '+',
        openedSymbol: '-'
      });
    };

    document.getElementById("nav-giorno").style.visibility = "visible";


    /*****************  per numero telefono cliente  ****************** */

    var inputNumTel = document.querySelector("#telDesktop");
    var errorMsgNumTel = document.querySelector("#error-msg");
    var validMsgNumTel = document.querySelector("#valid-msg");

    // here, the index maps to the error code returned from getValidationError - see readme
    var errorMap = [t("invnumb", pp(), "Numero non valido"), t("invccode", pp(), "Codice nazione non valido"), t("tooshort", pp(), "Troppo corto"), t("toolong", pp(), "Troppo lungo"), t("invnumb", pp(), "Numero non valido")];

    // initialise plugin
    iti = window.intlTelInput(inputNumTel, {
      initialCountry: "auto",
      separateDialCode: true,
      geoIpLookup: function (callback) {
        $.get('http://commander.eugenium.it/ip.php', function () { }, "json").always(function (resp) {
          var countryCode = (resp && resp.country) ? resp.country.toLowerCase() : "it";
          callback(countryCode);
        });
      },
      utilsScript: "js/intl-tel/js/utils.js"
    });

    var reset = function () {
      errorMsgNumTel.innerHTML = "";
      errorMsgNumTel.style.display = "none";
      validMsgNumTel.style.display = "none";
    };

    // on blur: validate
    inputNumTel.addEventListener("blur", function () {
      reset();
      if (inputNumTel.value.trim()) {
        if (iti.isValidNumber()) {
          validMsgNumTel.style.display = "block";
        } else {
          var errorCode = iti.getValidationError();
          errorMsgNumTel.innerHTML = errorMap[errorCode];
          errorMsgNumTel.style.display = "block";
        }
      }
    });

    // on keyup / change flag: reset
    inputNumTel.addEventListener("change", reset);
    inputNumTel.addEventListener("keyup", reset);

    /************************************* */

  });


})(jQuery);